import { groupMessagesByDate } from '../../Message/util/message.util';
import { ConversationThreadMessage, ConversationThreadMessageProps } from './ConversationThreadMessage';
import {
  Conversation,
  ConversationMessagesSkeleton,
  DateDivider,
  FreeformMessage,
  useSelf,
} from '@elements-financial/elements';

interface GroupedMessagesProps {
  messagesLoading?: boolean;
  conversation?: Conversation;
  messages: FreeformMessage[];
  dateDividerOverride?: (p: { date: Date }) => React.ReactNode | null;
  conversationThreadMessageProps: Pick<
    ConversationThreadMessageProps,
    | 'messageExpandableTagListProps'
    | 'optimisticSelfParticipantType'
    | 'onboardingReminderElement'
    | 'linkifyAnchorRenderer'
  >;
}

export function GroupedMessages({
  messages,
  conversation,
  messagesLoading,
  dateDividerOverride,
  conversationThreadMessageProps,
}: GroupedMessagesProps) {
  // useSelf used to be called inside of the ConversationThreadMessage component
  // However, this would mean one call per message in the thread, potentially thousands of calls
  // Instead, we can call it once here and pass the user object down to the children
  const { self } = useSelf();

  if (messagesLoading) return <ConversationMessagesSkeleton />;

  return (
    <>
      {groupMessagesByDate(messages).map(([dateString, messages]) => (
        <div className="mt-5 grid gap-4" key={dateString}>
          {dateDividerOverride ? (
            dateDividerOverride({ date: new Date(dateString) })
          ) : (
            <DateDivider date={new Date(dateString)} />
          )}
          {messages.map((message) => (
            <ConversationThreadMessage
              self={self}
              key={message.id}
              message={message}
              conversation={conversation}
              {...conversationThreadMessageProps}
            />
          ))}
        </div>
      ))}
    </>
  );
}
